import React from "react";
import "../../../css/TotalTimeRental.css";
import { PieChart, Pie, Tooltip, ResponsiveContainer } from "recharts";

interface TotalTimeRentalProps {
  TotalTimeRental: { time: string; count: number }[];
}

const TotalTimeRental: React.FC<TotalTimeRentalProps> = ({
  TotalTimeRental,
}) => {
  return (
    <div className="time_container">
      <h2 className="time_title">時間別レンタル割合(累計)</h2>
      <ResponsiveContainer width="100%" height="75%">
        <PieChart className="Piechart">
          <Pie
            data={TotalTimeRental}
            dataKey="count"
            nameKey="time"
            cx="50%"
            cy="50%"
            outerRadius={80}
            fill="#82ca9d"
            label
          />
          <Tooltip />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default TotalTimeRental;
